
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';

// const Breaking = () => {
//     const [data, setData] = useState({});
//     const [loading, setLoading] = useState(true);

//     // Define default static data matching the backend structure (assuming similar to Country/Politics)
//     const defaultData = {
//         main_news: {
//             featured: {
//                 title: "ब्रेकिंग न्यूज़ की ताज़ा खबरें",
//                 category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
//                 date: "2017-03-22T17:49",
//                 // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
//                 image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
//             },
//             list: [
//                 {
//                     title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
//                     // image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
//                     image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
//                     category: "News",
//                     date: "2017-03-22T17:50",
//                     description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
//                 },
//                 {
//                     title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
//                     // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
//                     image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
//                 },
//                 {
//                     title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
//                     // image: "/assets/img/11-1_1759952360.webp",
//                     image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
//                 }
//             ]
//         },
//         sidebar: {
//             // social_links: [
//             //     { platform: "facebook", icon: "fa fa-facebook", follows: "50k" },
//             //     { platform: "instagram", icon: "fa fa-instagram", follows: "10k" },
//             //     { platform: "youtube", icon: "fa fa-youtube", follows: "25k" },
//             //     { platform: "twitter", icon: "fa fa-twitter", follows: "20k" }
//             // ],
//             weather: {
//                 location: "Panna, IN",
//                 time: "6:03 pm, Oct 7, 2025",
//                 temperature: "42",
//                 condition: "19°C",
//                 // image: "/assets/img/rain-6243559_1280.jpg"
//                 image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688160/rain-6243559_1280_wu1xxh.jpg"
//             },
//             recent_news: [
//                 { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
//                 { title: "Someone Has Cal The Total Cost", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
//                 { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
//                 { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" }
//             ]
//         }
//     };

//     useEffect(() => {
//         let mounted = true;
//         const fetchData = async () => {
//             try {
//                 console.log("Fetching breaking news data...");
//                 const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/latestNews/all`);
//                 console.log("res : latestNes :", res, res.data)
//                 if (!mounted) return;
//                 const fetchedData = res.data.data[0] || defaultData;
//                 console.log("Fetched breaking news data:", fetchedData);
//                 setData(fetchedData);
//             } catch (err) {
//                 console.error("Error fetching breaking news:", err);
//                 setData(defaultData);
//             } finally {
//                 if (mounted) setLoading(false);
//             }
//         };
//         fetchData();
//         return () => {
//             mounted = false;
//         };
//     }, []);

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <>
//             <section className="section-space-bottom-less30 mt-lg-5">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-8 col-md-12 mb-30">
//                             <div className="topic-border color-cod-gray mb-30">
//                                 <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
//                             </div>
//                             <div className="img-overlay-70 img-scale-animate">
//                                 <img src={data.main_news?.featured?.image} alt="news" className="img-fluid" />
//                                 <div className="mask-content-lg">
//                                     <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
//                                     <div className="post-date-light">
//                                         <ul>
//                                             <li>
//                                                 <span>
//                                                     <i className="fa fa-calendar" style={{ color: "white" }} aria-hidden="true" />
//                                                 </span>{new Date(data.main_news?.featured?.date).toLocaleDateString()}
//                                             </li>

//                                             <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "white" }} />
//                                             <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
//                                             <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
//                                         </ul>
//                                     </div>
//                                     <h2 className="title-medium-light size-xl d-none d-sm-block">
//                                         <Link to="/news-info">{data.main_news?.featured?.category}</Link>
//                                     </h2>
//                                 </div>
//                             </div>
//                             <div className="item-box-light-md-less30 ie-full-width">
//                                 {data.main_news?.list?.map((item, index) => (
//                                     <div key={index} className="media mb-30 media-none--sm">
//                                         <div className="position-relative width-40">
//                                             <Link to="/news-info" className="img-opacity-hover">
//                                                 <img src={item.image} alt="news" className="img-fluid" />
//                                             </Link>
//                                             <div className="topic-box-top-xs">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
//                                             </div>
//                                         </div>
//                                         <div className="media-body p-mb-none-child media-margin30">
//                                             <div className="post-date-dark">
//                                                 <ul>
//                                                     <li>
//                                                         <span>
//                                                             <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                                                         </span>{new Date(item.date).toLocaleDateString()}

//                                                     </li>

//                                                     <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black" }} />
//                                                     <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
//                                                     <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />

//                                                 </ul>
//                                             </div>
//                                             <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
//                                                 <Link to="/news-info">{item.title}</Link>
//                                             </h3>
//                                             <p>{item.description}</p>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                         <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
//                             <div className="sidebar-box">
//                                 {/* <div className="topic-border color-cod-gray mb-30">
//                                     <div className="topic-box-lg color-cod-gray">Stay Connected</div>
//                                 </div> */}
//                                 <ul className="stay-connected-light overflow-hidden mb-20">
//                                     {data.sidebar?.social_links?.map((link, index) => (
//                                         <li key={index} className={link.platform}>
//                                             <Link to="#">
//                                                 {link.icon.startsWith('http') || link.icon.startsWith('/') ? (
//                                                     <img src={link.icon} alt={link.platform} style={{ width: '20px', height: '20px' }} />
//                                                 ) : (
//                                                     <i className={link.icon} aria-hidden="true" />
//                                                 )}
//                                                 <div className="connection-quantity">{link.follows}</div>
//                                             </Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                             <div className="sidebar-box">
//                                 <div className="topic-border color-cod-gray">
//                                     <div className="topic-box-lg color-cod-gray">Weather</div>
//                                 </div>
//                                 <br />
//                                 <div className="img-overlay-70 img-scale-animate">
//                                     <img src={data.sidebar?.weather?.image} alt="news" className="img-fluid" />
//                                     <div className="mask-content-lg">
//                                         <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">{data.sidebar?.weather?.location}</div>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li style={{ fontSize: "18px" }}>
//                                                     <span>
//                                                         <i className="fa fa-clock-o" aria-hidden="true" />
//                                                     </span>{data.sidebar?.weather?.time}
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h2 className="title-medium-light size-xl d-none d-sm-block">
//                                             <p>{data.sidebar?.weather?.condition}</p>
//                                         </h2>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="sidebar-box">
//                                 <div className="topic-border color-cod-gray">
//                                     <div className="topic-box-lg color-cod-gray">Recent News</div>
//                                 </div>
//                                 <div className="row">
//                                     {data.sidebar?.recent_news?.map((news, index) => (
//                                         <div key={index} className="col-lg-6 col-md-4 col-sm-6 col-6 mt-30">
//                                             <div className="item-shadow-gray">
//                                                 <div className="position-relative">
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">News</div>
//                                                     </div>
//                                                     <Link to="/news-info" className="img-opacity-hover">
//                                                         <img src={news.image} alt="news" className="img-fluid" />
//                                                     </Link>
//                                                 </div>
//                                                 <div className="box-padding15 bg-body item-shadow-gray">
//                                                     <h3 className="title-medium-dark size-sm mb-10">
//                                                         <Link to="/news-info">{news.title}</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default Breaking;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Breaking = () => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [likedNews, setLikedNews] = useState({});
    const [likeCounts, setLikeCounts] = useState({});
    const [commentCounts, setCommentCounts] = useState({});
    const [selectedNewsId, setSelectedNewsId] = useState(null);
    const [showCommentModal, setShowCommentModal] = useState(false);


    const defaultData = {
        main_news: {
            featured: {
                title: "ब्रेकिंग न्यूज़ की ताज़ा खबरें",
                category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
                date: "2017-03-22T17:49",
                image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
            },
            list: [
                {
                    _id: "1",
                    title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
                    category: "News",
                    date: "2017-03-22T17:50",
                    description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है।"
                },
                {
                    _id: "2",
                    title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है।"
                },
                {
                    _id: "3",
                    title: "नागपुर से मिला था छिंदवाड़ा को 'मौत का अलर्ट:– Madhya Pradesh News",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था।"
                }
            ]
        },
        sidebar: {
            weather: {
                location: "Panna, IN",
                time: "6:03 pm, Oct 7, 2025",
                temperature: "42",
                condition: "19°C",
                image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688160/rain-6243559_1280_wu1xxh.jpg"
            },
            recent_news: [
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Someone Has Cal The Total Cost", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" },
                { title: "Rosie Hutin Ghton Habits Career.", image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688148/blog1_gycnzk.jpg" }
            ]
        }
    };

    const getDeviceId = () => {
        let deviceId = localStorage.getItem('deviceId');
        if (!deviceId) {
            deviceId = 'device_' + Math.random().toString(36).substr(2, 9) + Date.now();
            localStorage.setItem('deviceId', deviceId);
        }
        return deviceId;
    };

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            try {
                console.log("Fetching breaking news data...");
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/latestNews/all`);
                console.log("res : latestNes :", res, res.data);
                if (!mounted) return;
                const fetchedData = res.data.data[0] || defaultData;
                console.log("Fetched breaking news data:", fetchedData);
                setData(fetchedData);

                // Fetch likes and comments for featured news
                if (fetchedData.main_news?.featured?._id) {
                    fetchLikeStatus(fetchedData.main_news.featured._id);
                    fetchCommentCount(fetchedData.main_news.featured._id);
                }

                // Fetch likes and comments for all news items
                if (fetchedData.main_news?.list) {
                    fetchedData.main_news.list.forEach(item => {
                        if (item._id) {
                            fetchLikeStatus(item._id);
                            fetchCommentCount(item._id);
                        }
                    });
                }
            } catch (err) {
                console.error("Error fetching breaking news:", err);
                setData(defaultData);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetchData();
        return () => {
            mounted = false;
        };
    }, []);

    const fetchLikeStatus = async (newsId) => {
        try {
            const deviceId = getDeviceId();
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/v1/users/likes/${newsId}`,
                { params: { deviceId } }
            );
            setLikedNews(prev => ({ ...prev, [newsId]: res.data.data.userLiked }));
            setLikeCounts(prev => ({ ...prev, [newsId]: res.data.data.totalLikes }));
        } catch (err) {
            console.error("Error fetching like status:", err);
        }
    };

    const fetchCommentCount = async (newsId) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}api/v1/users/comments/${newsId}`
            );
            setCommentCounts(prev => ({ ...prev, [newsId]: res.data.data.totalComments }));
        } catch (err) {
            console.error("Error fetching comments:", err);
        }
    };

    const handleLike = async (newsId) => {
        try {
            const deviceId = getDeviceId();
            console.log("Toggling like for newsId:", newsId, "with deviceId:", deviceId);
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}api/v1/users/like/${newsId}`,
                { deviceId }
            );
            console.log("Like toggled response:", res);
            setLikedNews(prev => ({ ...prev, [newsId]: res.data.data.liked }));
            setLikeCounts(prev => ({ ...prev, [newsId]: res.data.data.totalLikes }));
        } catch (err) {
            console.error("Error toggling like:", err);
            alert("Failed to toggle like. Please try again.");
        }
    };

    const handleComment = (newsId) => {
        setSelectedNewsId(newsId);
        setShowCommentModal(true);
    };

    const handleShare = async (newsId, title) => {
        const shareUrl = `${window.location.origin}/news/${newsId}`;
        console.log("Preparing to share:", shareUrl);
        const shareText = title;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: shareText,
                    url: shareUrl
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error("Error sharing:", err);
                }
            }
        } else {
            // Fallback: copy to clipboard
            try {
                await navigator.clipboard.writeText(shareUrl);
                alert('Link copied to clipboard!');
            } catch (err) {
                console.error("Error copying to clipboard:", err);
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = shareUrl;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                alert('Link copied to clipboard!');
            }
        }
    };

    const closeCommentModal = () => {
        setShowCommentModal(false);
        // Refresh comment count after closing
        if (selectedNewsId) {
            fetchCommentCount(selectedNewsId);
        }
        setSelectedNewsId(null);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <section className="section-space-bottom-less30 mt-lg-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-12 mb-30">
                            <div className="topic-border color-cod-gray mb-30">
                                <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
                            </div>
                            <div className="img-overlay-70 img-scale-animate">
                                <img src={data.main_news?.featured?.image} alt="news" className="img-fluid" />
                                <div className="mask-content-lg">
                                    <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
                                    <div className="post-date-light">
                                        <ul>
                                            <li>
                                                <span>
                                                    <i className="fa fa-calendar" style={{ color: "white" }} aria-hidden="true" />
                                                </span>{new Date(data.main_news?.featured?.date).toLocaleDateString()}
                                            </li>

                                            <i
                                                className="fa fa-share-alt"
                                                style={{ fontSize: "25px", color: "white", cursor: "pointer" }}
                                                onClick={() => handleShare(data.main_news?.featured?._id, data.main_news?.featured?.title)}
                                            />
                                            <i
                                                className={`fa fa-thumbs-o-up ${likedNews[data.main_news?.featured?._id] ? 'like-red' : 'like-white'}`}
                                                style={{ fontSize: "25px", margin: "10px", cursor: "pointer" }}
                                                onClick={() => handleLike(data.main_news?.featured?._id)}
                                            />
                                            <span style={{ color: "white", marginRight: "10px" }}>
                                                {likeCounts[data.main_news?.featured?._id] || 0}
                                            </span>
                                            <i
                                                className="fa fa-commenting-o"
                                                style={{ fontSize: "25px", color: "white", margin: "10px", cursor: "pointer" }}
                                                onClick={() => handleComment(data.main_news?.featured?._id)}
                                            />
                                            <span style={{ color: "white" }}>
                                                {commentCounts[data.main_news?.featured?._id] || 0}
                                            </span>
                                        </ul>
                                    </div>
                                    <h2 className="title-medium-light size-xl d-none d-sm-block">
                                        {/* <Link to="/news-info"> */}
                                        <Link to={`/news/${data.main_news?.featured?._id}`}>

                                            {data.main_news?.featured?.category}</Link>
                                    </h2>
                                </div>
                            </div>
                            <div className="item-box-light-md-less30 ie-full-width">
                                {data.main_news?.list?.map((item, index) => (
                                    <div key={item._id || index} className="media mb-30 media-none--sm">
                                        <div className="position-relative width-40">
                                            <Link to="/news-info" className="img-opacity-hover">
                                                <img src={item.image} alt="news" className="img-fluid" />
                                            </Link>
                                            <div className="topic-box-top-xs">
                                                <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
                                            </div>
                                        </div>
                                        <div className="media-body p-mb-none-child media-margin30">
                                            <div className="post-date-dark">
                                                <ul>
                                                    <li>
                                                        <span>
                                                            <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
                                                        </span>{new Date(item.date).toLocaleDateString()}
                                                    </li>

                                                    <i
                                                        className="fa fa-share-alt"
                                                        style={{ fontSize: "25px", color: "black", cursor: "pointer" }}
                                                        onClick={() => handleShare(item._id, item.title)}
                                                    />
                                                    <i
                                                        className={`fa fa-thumbs-o-up ${likedNews[item._id] ? 'like-red' : ''}`}
                                                        style={{ fontSize: "25px", color: likedNews[item._id] ? "red" : "black", margin: "10px", cursor: "pointer" }}
                                                        onClick={() => handleLike(item._id)}
                                                    />
                                                    <span style={{ color: "black", marginRight: "10px" }}>
                                                        {likeCounts[item._id] || 0}
                                                    </span>
                                                    <i
                                                        className="fa fa-commenting-o"
                                                        style={{ fontSize: "25px", color: "black", margin: "10px", cursor: "pointer" }}
                                                        onClick={() => handleComment(item._id)}
                                                    />
                                                    <span style={{ color: "black" }}>
                                                        {commentCounts[item._id] || 0}
                                                    </span>
                                                </ul>
                                            </div>
                                            <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
                                                {/* <Link to="/news-info"> */}
                                                <Link to={`/news/${item._id}`}>

                                                    {item.title}</Link>
                                            </h3>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
                            <div className="sidebar-box">
                                <ul className="stay-connected-light overflow-hidden mb-20">
                                    {data.sidebar?.social_links?.map((link, index) => (
                                        <li key={index} className={link.platform}>
                                            <Link to="#">
                                                {link.icon.startsWith('http') || link.icon.startsWith('/') ? (
                                                    <img src={link.icon} alt={link.platform} style={{ width: '20px', height: '20px' }} />
                                                ) : (
                                                    <i className={link.icon} aria-hidden="true" />
                                                )}
                                                <div className="connection-quantity">{link.follows}</div>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="sidebar-box">
                                <div className="topic-border color-cod-gray">
                                    <div className="topic-box-lg color-cod-gray">राशिफल</div>
                                </div>
                                <br />
                                <div id="text-11" className="container-wrapper widget widget_text">

                                    <div className="textwidget">
                                        <div style={{ height: 300 }}>
                                            <iframe src="https://piushtrivedi.neocities.org/hindi_astrology_google_gadget_part_1_updated_html2.html" width="100%" height="100%" frameBorder={0} scrolling="no" />
                                        </div>
                                    </div>
                                    <div className="clearfix" />
                                </div>

                                {/* <div className="img-overlay-70 img-scale-animate">
                                    <img src={data.sidebar?.weather?.image} alt="news" className="img-fluid" />
                                    <div className="mask-content-lg">
                                        <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">{data.sidebar?.weather?.location}</div>
                                        <div className="post-date-light">
                                            <ul>
                                                <li style={{ fontSize: "18px" }}>
                                                    <span>
                                                        <i className="fa fa-clock-o" aria-hidden="true" />
                                                    </span>{data.sidebar?.weather?.time}
                                                </li>
                                            </ul>
                                        </div>
                                        <h2 className="title-medium-light size-xl d-none d-sm-block">
                                            <p>{data.sidebar?.weather?.condition}</p>
                                        </h2>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="sidebar-box">
                                <div className="topic-border color-cod-gray">
                                    <div className="topic-box-lg color-cod-gray">Recent News</div>
                                </div>
                                <div className="row">
                                    {data.sidebar?.recent_news?.map((news, index) => (
                                        <div key={index} className="col-lg-6 col-md-4 col-sm-6 col-6 mt-30">
                                            <div className="item-shadow-gray">
                                                <div className="position-relative">
                                                    <div className="topic-box-top-xs">
                                                        <div className="topic-box-sm color-cod-gray mb-20">News</div>
                                                    </div>
                                                    <Link to="/news-info" className="img-opacity-hover">
                                                        <img src={news.image} alt="news" className="img-fluid" />
                                                    </Link>
                                                </div>
                                                <div className="box-padding15 bg-body item-shadow-gray">
                                                    <h3 className="title-medium-dark size-sm mb-10">
                                                        <Link to="/news-info"></Link>
                                                        <Link to={`/news/${item._id}`}>

                                                        {news.title}</Link>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            {/* Comment Modal */}
            {showCommentModal && selectedNewsId && (
                <CommentModal
                    newsId={selectedNewsId}
                    onClose={closeCommentModal}
                />
            )}
        </>
    );
};

// Comment Modal Component
const CommentModal = ({ newsId, onClose }) => {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (newsId) fetchComments();
    }, [newsId]);

    const fetchComments = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/comments/${newsId}`);
            setComments(res.data.data.comments || []);
        } catch (err) {
            console.error("Error fetching comments:", err);
        } finally {
            setLoading(false);
        }
    };

    const submitComment = async () => {
        if (!name.trim() || !message.trim()) {
            alert('Name and Message are required!');
            return;
        }

        if (name.trim().length > 50) {
            alert('Name must be less than 50 characters');
            return;
        }

        if (message.trim().length > 500) {
            alert('Message must be less than 500 characters');
            return;
        }

        setSubmitting(true);
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}api/v1/users/comment/${newsId}`, {
                name: name.trim(),
                message: message.trim()
            });
            setName('');
            setMessage('');
            fetchComments();
        } catch (err) {
            console.error("Error submitting comment:", err);
            alert('Failed to submit comment. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0 }}>Comments</h3>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '0',
                            lineHeight: '1'
                        }}
                    >
                        ×
                    </button>
                </div>

                <input
                    placeholder="Your  Name (max 50 chars)"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={50}
                    style={{
                        width: '100%',
                        padding: '10px',
                        marginBottom: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px'
                    }}
                />

                <textarea
                    placeholder="Your Comment (max 500 chars)"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={500}
                    rows={4}
                    style={{
                        width: '100%',
                        padding: '10px',
                        marginBottom: '5px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        resize: 'vertical'
                    }}
                />

                <div style={{ textAlign: 'right', fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                    {message.length}/500
                </div>

                <button
                    onClick={submitComment}
                    disabled={submitting}
                    style={{
                        width: '100%',
                        padding: '10px',
                        backgroundColor: submitting ? '#ccc' : '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: submitting ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }}
                >
                    {submitting ? 'Submitting...' : 'Submit Comment'}
                </button>

                <hr style={{ margin: '20px 0' }} />

                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {loading ? (
                        <p style={{ textAlign: 'center', color: '#666' }}>Loading comments...</p>
                    ) : comments.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#666' }}>No comments yet. Be the first to comment!</p>
                    ) : (
                        comments.map((c, i) => (
                            <div key={i} className="comment" style={{
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                borderRadius: '4px',
                                marginBottom: '10px'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                    <b style={{ color: '#333' }}>{c.name}</b>
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                        {new Date(c.date).toLocaleDateString('en-IN')}
                                    </span>
                                </div>
                                <p style={{ margin: 0, color: '#555', fontSize: '14px' }}>{c.message}</p>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};


export default Breaking;